import { useQuery } from "@tanstack/react-query";
import { Alert, Spinner } from "react-bootstrap";
import { HeaderDetail, TokenUsageFields } from "@bagel-web/components";

import { sessionQueries } from "../queries";
import { CommonAPI } from "../types";

// The Usage tab: the moment's token counts, presented like the session header's.
const AgentMomentUsage = ({
  sessionId,
  momentId,
  commonAPI,
}: {
  sessionId: string;
  momentId: number;
  commonAPI: CommonAPI;
}) => {
  const { data, isPending, isError } = useQuery({
    queryKey: sessionQueries.getMomentUsage(sessionId, momentId),
    queryFn: () => commonAPI.fetchMomentUsage({ sessionId, momentId }),
  });

  if (isPending) {
    return <Spinner className="mt-3" />;
  }
  if (isError) {
    return <Alert variant="danger">Error loading token usage</Alert>;
  }
  const usage = data.usage ?? [];
  if (usage.length === 0) {
    // An old moment with no usage may simply never have called a model.
    return data.retention_elapsed ? (
      <Alert variant="info">
        Token usage may be unavailable for Moments older than 90 days.
      </Alert>
    ) : (
      <p>No token usage recorded for this Moment.</p>
    );
  }

  return (
    <HeaderDetail>
      <TokenUsageFields usage={usage} />
    </HeaderDetail>
  );
};

export default AgentMomentUsage;
